import React from 'react';
import PropTypes from 'prop-types';
import { SendOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

// DS
import {
  Col,
  VertTypography,
  VertIcon,
  VertInput,
  VertButton,
} from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Checkout/CheckoutVoucherStyles.less';
import ynToBool from '../../../Utils/ynToBool';
import { maskEmails } from 'Utils/maskFormat';

// UTILS

// CHECKOUT PERSONAL DATA COMPONENT
const CheckoutVoucher = ({ ...props }) => {
  const { emailToSend, hasItemsVirtualVoucher } = props;

  const maskedEmail = maskEmails(emailToSend);

  const navigate = useNavigate();

  if (hasItemsVirtualVoucher) {
    return (
      <Col className="checkout-voucher-wrapper col-12 col-md-auto">
        <Col className="checkout-voucher-title">
          <VertIcon component={SendOutlined} />
          <VertTypography.Title>
            Envio de voucher por e-mail
          </VertTypography.Title>
        </Col>

        <Col className="col-10 col-md-7 checkout-voucher-content">
          <div className="checkout-voucher-info">
            <VertTypography.Paragraph>
              O Voucher será enviado para o e-mail cadastrado.
            </VertTypography.Paragraph>
            <VertTypography.Text>
              Verifique se possui acesso ao e-mail cadastrado.
              <br />
              Após o fechamento do pedido, não será possível alterar o e-mail
              para o envio ou reenvio do voucher.
            </VertTypography.Text>
          </div>

          <VertInput
            value={maskedEmail}
            disabled
            placeholder="Email de Envio"
          />
          {!ynToBool(process.env.REACT_APP_BLOCK_EMAIL_CHANGE_BUTTON) && (
            <VertButton spacing="default" onClick={() => navigate('/profile')}>
              Meu e-mail está incorreto
            </VertButton>
          )}
        </Col>
      </Col>
    );
  }
  return '';
};

CheckoutVoucher.propTypes = {
  emailToSend: PropTypes.string,
  hasItemsVirtualVoucher: PropTypes.bool,
};

export default CheckoutVoucher;
